import React, { useState } from "react";
import API_URLS from "../../summaryapi/apiUrls";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const EmployeeInfoForm = () => {
  const [formData, setFormData] = useState({
    employee_name: "",
    phone_number: "",
    password: "", // You can allow this to be editable if needed
    additional_information: "",
    address: "",
    is_active: true
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({
    success: null,
    message: ""
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ success: null, message: "" });

    try {
      const response = await fetch(API_URLS.createemployee.url, {
        method: API_URLS.createemployee.method,
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to create employee");
      }

      if (data.status) {
        setSubmitStatus({
          success: true,
          message: "Employee created successfully!"
        });
        // Show success toast
        toast.success("Employee created successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        
        setFormData({
          employee_name: "",
          phone_number: "",
          password: "",
          additional_information: "",
          address: "",
          is_active: true
        });
      } else {
        setSubmitStatus({
          success: false,
          message: data.message || "Failed to create employee"
        });
        // Show error toast
        toast.error(data.message || "Failed to create employee", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {

    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-centerpy-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl w-full space-y-8 p-8 shadow rounded-lg">
        <h1 className="text-2xl font-bold text-gray-800 text-center">Create Voluntary</h1>

        {submitStatus.message && (
          <div className={`p-4 rounded-md ${submitStatus.success ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
            {submitStatus.message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-gray-700 mb-2">Full Name</label>
            <input
              type="text"
              name="employee_name"
              value={formData.employee_name}
              onChange={handleChange}
              className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700 mb-2">Mobile Number</label>
            <input
              type="tel"
              name="phone_number"
              value={formData.phone_number}
              onChange={handleChange}
              className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
              maxLength={10}
            />
          </div>

          <div>
            <label className="block text-gray-700 mb-2">Password</label>
            <input
              type="text"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700 mb-2">Address</label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleChange}
              className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              rows="3"
            ></textarea>
          </div>

          <div>
            <label className="block text-gray-700 mb-2">Additional Information</label>
            <textarea
              name="additional_information"
              value={formData.additional_information}
              onChange={handleChange}
              className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              rows="3"
            ></textarea>
          </div>



          <button
            type="submit"
            disabled={isSubmitting}
            className={`w-full ${isSubmitting ? 'bg-blue-400' : 'bg-blue-500 hover:bg-blue-600'} text-white py-3 rounded-md transition duration-200`}
          >
            {isSubmitting ? 'Submitting...' : 'Create'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EmployeeInfoForm;
